import type { PlatformHelpers } from 'Models/uiConfig/platformHelpers';

export function getCountry(): string | undefined {
  return window.Convermax.BigCommerce?.country;
}

export function getCustomerGroupId(): string | undefined {
  return window.Convermax.BigCommerce?.customerGroupId;
}

export function getCustomerId(): string | undefined {
  return window.Convermax.BigCommerce?.customerId;
}

export const isLoggedIn = window.Convermax.BigCommerce?.isLoggedIn;

/**
 * Single source of truth for the BigCommerce-specific values that flow through
 * `window.Convermax.BigCommerce`. Keep this in sync with the runtime values
 * assigned by `getCustomerAsync` in `requestConfig.ts`.
 */
type ConvermaxBigCommerceState = {
  isLoggedIn?: boolean;
  country?: string;
  customerGroupId?: string;
  customerId?: string;
};

export type ConvermaxBigCommerceGlobal = ConvermaxBigCommerceState & ConvermaxBigCommerceHelpers;

type ConvermaxBigCommerceHelpers = {
  isLoggedIn: ConvermaxBigCommerceState['isLoggedIn'];
  getCustomerGroupId: () => ConvermaxBigCommerceState['customerGroupId'];
  getCustomerId: () => ConvermaxBigCommerceState['customerId'];
  getCountry: () => ConvermaxBigCommerceState['country'];
};

const bigcommerceHelpers: ConvermaxBigCommerceHelpers = {
  isLoggedIn,
  getCustomerGroupId,
  getCustomerId,
  getCountry,
};

export function initializePlatformHelpers(): void {
  window.Convermax.BigCommerce = {
    ...(window.Convermax.BigCommerce || {}),
    ...bigcommerceHelpers,
  };
}
const platformHelpers = {
  initializePlatformHelpers,
} satisfies Partial<PlatformHelpers>;
export default platformHelpers;
